(() => {
    const form = document.getElementById('mhpss-fit-form');
    const config = document.getElementById('mhpss-fit-content-config');

    if (!form || !config) {
        return;
    }

    const progress = document.getElementById('fit-progress');
    const result = document.getElementById('fit-result');
    const resultTitle = document.getElementById('result-title');
    const resultSummary = document.getElementById('result-summary');
    const resultGaps = document.getElementById('result-gaps');
    const resultActions = document.getElementById('result-actions');
    const showResultButton = document.getElementById('show-result');
    const questionNames = [...form.querySelectorAll('fieldset.mhpss-decision')]
        .map((fieldset) => fieldset.querySelector('input[type="radio"]')?.name)
        .filter((name, index, names) => name && names.indexOf(name) === index);
    const routes = Object.fromEntries([...config.querySelectorAll('[data-mhpss-route]')].map((node) => [
        node.dataset.mhpssRoute,
        {
            title: node.querySelector('[data-title]')?.textContent.trim() || '',
            summary: node.querySelector('[data-summary]')?.textContent.trim() || '',
            actions: [...node.querySelectorAll('[data-action]')].map((action) => ({
                label: action.textContent.trim(),
                href: action.getAttribute('href') || ''
            }))
        }
    ]));
    const classification = {};

    config.querySelectorAll('[data-mhpss-classification]').forEach((node) => {
        const question = node.dataset.question;
        const value = node.dataset.value;
        classification[question] ||= {};
        classification[question][value] = {
            state: node.dataset.state,
            gap: node.dataset.gap || ''
        };
    });

    function progressText(completed) {
        return config.dataset.progressTemplate
            .replace('{completed}', String(completed))
            .replace('{total}', String(questionNames.length));
    }

    function selectedValue(name) {
        return form.querySelector(`input[name="${name}"]:checked`)?.value || null;
    }

    function updateProgress() {
        progress.textContent = progressText(questionNames.filter(selectedValue).length);

        if (!result.hidden) {
            result.hidden = true;
        }
    }

    function renderActions(actions) {
        resultActions.replaceChildren();

        actions.forEach(({label, href}) => {
            const element = document.createElement(href === '#print' ? 'button' : 'a');
            element.className = href === '#print' ? 'mhpss-button mhpss-print-action' : 'mhpss-button';
            element.textContent = label;

            if (href === '#print') {
                element.type = 'button';
                element.addEventListener('click', () => window.print());
            } else {
                element.href = href;
                element.target = '_blank';
                element.rel = 'noopener noreferrer';
            }

            resultActions.appendChild(element);
        });
    }

    function renderGaps(gaps) {
        resultGaps.replaceChildren();

        if (!gaps.length) {
            const paragraph = document.createElement('p');
            const strong = document.createElement('strong');
            strong.textContent = config.dataset.noGaps;
            paragraph.appendChild(strong);
            resultGaps.appendChild(paragraph);
            return;
        }

        const heading = document.createElement('h4');
        const list = document.createElement('ul');
        heading.textContent = config.dataset.gapsTitle;
        gaps.forEach((gap) => {
            const item = document.createElement('li');
            item.textContent = gap;
            list.appendChild(item);
        });
        resultGaps.append(heading, list);
    }

    function showResult() {
        const missing = questionNames.find((name) => !selectedValue(name));

        if (missing) {
            progress.textContent = `${progressText(questionNames.filter(selectedValue).length)} ${config.dataset.incompleteSuffix}`;
            form.querySelector(`input[name="${missing}"]`)?.focus();
            result.hidden = true;
            return;
        }

        const assessments = questionNames.map((name) => {
            const value = selectedValue(name);
            return classification[name]?.[value];
        });

        if (assessments.some((assessment) => !assessment)) {
            result.hidden = true;
            return;
        }

        let route = 'potential';

        if (assessments.some((item) => item.state === 'different')) {
            route = 'different';
        } else if (assessments.some((item) => item.state === 'block')) {
            route = 'not-ready';
        } else if (assessments.some((item) => item.state === 'gap')) {
            route = 'conditional';
        }

        const gaps = assessments.filter((item) => item.gap).map((item) => item.gap);
        const content = routes[route];

        if (!content) {
            result.hidden = true;
            return;
        }

        result.dataset.state = route;
        resultTitle.textContent = content.title;
        resultSummary.textContent = content.summary;
        renderGaps(gaps);
        renderActions(content.actions);
        result.hidden = false;
        result.scrollIntoView({behavior: 'smooth', block: 'start'});
        result.focus({preventScroll: true});
    }

    form.addEventListener('change', updateProgress);
    form.addEventListener('reset', () => {
        window.setTimeout(() => {
            progress.textContent = progressText(0);
            result.hidden = true;
            result.dataset.state = '';
            resultGaps.replaceChildren();
            resultActions.replaceChildren();
        }, 0);
    });
    showResultButton?.addEventListener('click', showResult);
})();
